// Generated by ReScript, PLEASE EDIT WITH CARE
'use strict';

var $$Array = require("rescript/lib/js/array.js");
var Curry = require("rescript/lib/js/curry.js");
var Decco = require("decco/src/Decco.bs.js");
var Js_dict = require("rescript/lib/js/js_dict.js");
var Js_json = require("rescript/lib/js/js_json.js");
var Belt_Array = require("rescript/lib/js/belt_Array.js");
var Belt_Option = require("rescript/lib/js/belt_Option.js");
var OptionUtils$SmartcutsMacros = require("../../../bs-utils/src/OptionUtils.bs.js");
var StringUtils$SmartcutsMacros = require("../../../bs-utils/src/StringUtils.bs.js");
var PromisedValue$SmartcutsMacros = require("../PromisedValue.bs.js");
var InterfaceBtwnRecordingAndPlayback$SmartcutsMacros = require("../InterfaceBtwnRecordingAndPlayback.bs.js");

function t_encode(encoder_newTab, v) {
  return Js_dict.fromArray([
              [
                "newTab",
                Curry._1(encoder_newTab, v.newTab)
              ],
              [
                "openerTab",
                InterfaceBtwnRecordingAndPlayback$SmartcutsMacros.TabRef.t_encode(v.openerTab)
              ],
              [
                "newTabUrl",
                Decco.optionToJson(Decco.stringToJson, v.newTabUrl)
              ]
            ]);
}

function t_decode(decoder_newTab, v) {
  var dict = Js_json.classify(v);
  if (typeof dict === "number") {
    return Decco.error(undefined, "Not an object", v);
  }
  if (dict.TAG !== /* JSONObject */2) {
    return Decco.error(undefined, "Not an object", v);
  }
  var dict$1 = dict._0;
  var newTab = Curry._1(decoder_newTab, Belt_Option.getWithDefault(Js_dict.get(dict$1, "newTab"), null));
  if (newTab.TAG === /* Ok */0) {
    var openerTab = InterfaceBtwnRecordingAndPlayback$SmartcutsMacros.TabRef.t_decode(Belt_Option.getWithDefault(Js_dict.get(dict$1, "openerTab"), null));
    if (openerTab.TAG === /* Ok */0) {
      var newTabUrl = Decco.optionFromJson(Decco.stringFromJson, Belt_Option.getWithDefault(Js_dict.get(dict$1, "newTabUrl"), null));
      if (newTabUrl.TAG === /* Ok */0) {
        return {
                TAG: /* Ok */0,
                _0: {
                  newTab: newTab._0,
                  openerTab: openerTab._0,
                  newTabUrl: newTabUrl._0
                }
              };
      }
      var e = newTabUrl._0;
      return {
              TAG: /* Error */1,
              _0: {
                path: ".newTabUrl" + e.path,
                message: e.message,
                value: e.value
              }
            };
    }
    var e$1 = openerTab._0;
    return {
            TAG: /* Error */1,
            _0: {
              path: ".openerTab" + e$1.path,
              message: e$1.message,
              value: e$1.value
            }
          };
  }
  var e$2 = newTab._0;
  return {
          TAG: /* Error */1,
          _0: {
            path: ".newTab" + e$2.path,
            message: e$2.message,
            value: e$2.value
          }
        };
}

function stringify(stringifyNewTab, t) {
  return "{ newTab: " + (Curry._1(stringifyNewTab, t.newTab) + (", openerTab: " + (InterfaceBtwnRecordingAndPlayback$SmartcutsMacros.TabRef.stringify(t.openerTab) + (", newTabUrl: " + (OptionUtils$SmartcutsMacros.stringify(StringUtils$SmartcutsMacros.quote, t.newTabUrl) + " }")))));
}

var DownloadInNewTab = {
  t_encode: t_encode,
  t_decode: t_decode,
  stringify: stringify
};

function t_encode$1(encoder_newTab, v) {
  if (v.TAG === /* DownloadInNewTab */0) {
    return [
            "DownloadInNewTab",
            t_encode(encoder_newTab, v._0)
          ];
  } else {
    return [
            "DownloadInOriginalTab",
            InterfaceBtwnRecordingAndPlayback$SmartcutsMacros.TabRef.t_encode(v._0)
          ];
  }
}

function t_decode$1(decoder_newTab, v) {
  var jsonArr = Js_json.classify(v);
  if (typeof jsonArr === "number") {
    return Decco.error(undefined, "Not a variant", v);
  }
  if (jsonArr.TAG !== /* JSONArray */3) {
    return Decco.error(undefined, "Not a variant", v);
  }
  var jsonArr$1 = jsonArr._0;
  if (jsonArr$1.length === 0) {
    return Decco.error(undefined, "Expected variant, found empty array", v);
  }
  var tagged = jsonArr$1.map(Js_json.classify);
  var match = Belt_Array.getExn(tagged, 0);
  if (typeof match !== "number" && match.TAG === /* JSONString */0) {
    switch (match._0) {
      case "DownloadInNewTab" :
          if (tagged.length !== 2) {
            return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
          }
          var v0 = t_decode(decoder_newTab, Belt_Array.getExn(jsonArr$1, 1));
          if (v0.TAG === /* Ok */0) {
            return {
                    TAG: /* Ok */0,
                    _0: {
                      TAG: /* DownloadInNewTab */0,
                      _0: v0._0
                    }
                  };
          }
          var e = v0._0;
          return {
                  TAG: /* Error */1,
                  _0: {
                    path: "[0]" + e.path,
                    message: e.message,
                    value: e.value
                  }
                };
      case "DownloadInOriginalTab" :
          if (tagged.length !== 2) {
            return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
          }
          var v0$1 = InterfaceBtwnRecordingAndPlayback$SmartcutsMacros.TabRef.t_decode(Belt_Array.getExn(jsonArr$1, 1));
          if (v0$1.TAG === /* Ok */0) {
            return {
                    TAG: /* Ok */0,
                    _0: {
                      TAG: /* DownloadInOriginalTab */1,
                      _0: v0$1._0
                    }
                  };
          }
          var e$1 = v0$1._0;
          return {
                  TAG: /* Error */1,
                  _0: {
                    path: "[0]" + e$1.path,
                    message: e$1.message,
                    value: e$1.value
                  }
                };
      default:
        
    }
  }
  return Decco.error(undefined, "Invalid variant constructor", Belt_Array.getExn(jsonArr$1, 0));
}

function stringify$1(stringifyNewTab, v) {
  if (v.TAG === /* DownloadInNewTab */0) {
    return "DownloadInNewTab(" + (stringify(stringifyNewTab, v._0) + ")");
  } else {
    return "DownloadInOriginalTab(" + (InterfaceBtwnRecordingAndPlayback$SmartcutsMacros.TabRef.stringify(v._0) + ")");
  }
}

var DownloadTabOrigin = {
  DownloadInNewTab: DownloadInNewTab,
  t_encode: t_encode$1,
  t_decode: t_decode$1,
  stringify: stringify$1
};

function t_encode$2(v) {
  return Js_dict.fromArray([
              [
                "chromeId",
                Decco.intToJson(v.chromeId)
              ],
              [
                "url",
                Decco.stringToJson(v.url)
              ],
              [
                "finalUrl",
                Decco.stringToJson(v.finalUrl)
              ],
              [
                "referrer",
                Decco.stringToJson(v.referrer)
              ],
              [
                "filename",
                Decco.stringToJson(v.filename)
              ],
              [
                "mime",
                Decco.stringToJson(v.mime)
              ],
              [
                "startTime",
                Decco.floatToJson(v.startTime)
              ],
              [
                "estimatedEndTime",
                Decco.optionToJson(Decco.floatToJson, v.estimatedEndTime)
              ],
              [
                "totalBytes",
                Decco.floatToJson(v.totalBytes)
              ],
              [
                "fileSize",
                Decco.floatToJson(v.fileSize)
              ],
              [
                "tabOrigin",
                PromisedValue$SmartcutsMacros.t_encode((function (param) {
                        return t_encode$1(InterfaceBtwnRecordingAndPlayback$SmartcutsMacros.TabRef.t_encode, param);
                      }), Decco.unitToJson, v.tabOrigin)
              ]
            ]);
}

function t_decode$2(v) {
  var dict = Js_json.classify(v);
  if (typeof dict === "number") {
    return Decco.error(undefined, "Not an object", v);
  }
  if (dict.TAG !== /* JSONObject */2) {
    return Decco.error(undefined, "Not an object", v);
  }
  var dict$1 = dict._0;
  var chromeId = Decco.intFromJson(Belt_Option.getWithDefault(Js_dict.get(dict$1, "chromeId"), null));
  if (chromeId.TAG === /* Ok */0) {
    var url = Decco.stringFromJson(Belt_Option.getWithDefault(Js_dict.get(dict$1, "url"), null));
    if (url.TAG === /* Ok */0) {
      var finalUrl = Decco.stringFromJson(Belt_Option.getWithDefault(Js_dict.get(dict$1, "finalUrl"), null));
      if (finalUrl.TAG === /* Ok */0) {
        var referrer = Decco.stringFromJson(Belt_Option.getWithDefault(Js_dict.get(dict$1, "referrer"), null));
        if (referrer.TAG === /* Ok */0) {
          var filename = Decco.stringFromJson(Belt_Option.getWithDefault(Js_dict.get(dict$1, "filename"), null));
          if (filename.TAG === /* Ok */0) {
            var mime = Decco.stringFromJson(Belt_Option.getWithDefault(Js_dict.get(dict$1, "mime"), null));
            if (mime.TAG === /* Ok */0) {
              var startTime = Decco.floatFromJson(Belt_Option.getWithDefault(Js_dict.get(dict$1, "startTime"), null));
              if (startTime.TAG === /* Ok */0) {
                var estimatedEndTime = Decco.optionFromJson(Decco.floatFromJson, Belt_Option.getWithDefault(Js_dict.get(dict$1, "estimatedEndTime"), null));
                if (estimatedEndTime.TAG === /* Ok */0) {
                  var totalBytes = Decco.floatFromJson(Belt_Option.getWithDefault(Js_dict.get(dict$1, "totalBytes"), null));
                  if (totalBytes.TAG === /* Ok */0) {
                    var fileSize = Decco.floatFromJson(Belt_Option.getWithDefault(Js_dict.get(dict$1, "fileSize"), null));
                    if (fileSize.TAG === /* Ok */0) {
                      var tabOrigin = PromisedValue$SmartcutsMacros.t_decode((function (param) {
                              return t_decode$1(InterfaceBtwnRecordingAndPlayback$SmartcutsMacros.TabRef.t_decode, param);
                            }), Decco.unitFromJson, Belt_Option.getWithDefault(Js_dict.get(dict$1, "tabOrigin"), null));
                      if (tabOrigin.TAG === /* Ok */0) {
                        return {
                                TAG: /* Ok */0,
                                _0: {
                                  chromeId: chromeId._0,
                                  url: url._0,
                                  finalUrl: finalUrl._0,
                                  referrer: referrer._0,
                                  filename: filename._0,
                                  mime: mime._0,
                                  startTime: startTime._0,
                                  estimatedEndTime: estimatedEndTime._0,
                                  totalBytes: totalBytes._0,
                                  fileSize: fileSize._0,
                                  tabOrigin: tabOrigin._0
                                }
                              };
                      }
                      var e = tabOrigin._0;
                      return {
                              TAG: /* Error */1,
                              _0: {
                                path: ".tabOrigin" + e.path,
                                message: e.message,
                                value: e.value
                              }
                            };
                    }
                    var e$1 = fileSize._0;
                    return {
                            TAG: /* Error */1,
                            _0: {
                              path: ".fileSize" + e$1.path,
                              message: e$1.message,
                              value: e$1.value
                            }
                          };
                  }
                  var e$2 = totalBytes._0;
                  return {
                          TAG: /* Error */1,
                          _0: {
                            path: ".totalBytes" + e$2.path,
                            message: e$2.message,
                            value: e$2.value
                          }
                        };
                }
                var e$3 = estimatedEndTime._0;
                return {
                        TAG: /* Error */1,
                        _0: {
                          path: ".estimatedEndTime" + e$3.path,
                          message: e$3.message,
                          value: e$3.value
                        }
                      };
              }
              var e$4 = startTime._0;
              return {
                      TAG: /* Error */1,
                      _0: {
                        path: ".startTime" + e$4.path,
                        message: e$4.message,
                        value: e$4.value
                      }
                    };
            }
            var e$5 = mime._0;
            return {
                    TAG: /* Error */1,
                    _0: {
                      path: ".mime" + e$5.path,
                      message: e$5.message,
                      value: e$5.value
                    }
                  };
          }
          var e$6 = filename._0;
          return {
                  TAG: /* Error */1,
                  _0: {
                    path: ".filename" + e$6.path,
                    message: e$6.message,
                    value: e$6.value
                  }
                };
        }
        var e$7 = referrer._0;
        return {
                TAG: /* Error */1,
                _0: {
                  path: ".referrer" + e$7.path,
                  message: e$7.message,
                  value: e$7.value
                }
              };
      }
      var e$8 = finalUrl._0;
      return {
              TAG: /* Error */1,
              _0: {
                path: ".finalUrl" + e$8.path,
                message: e$8.message,
                value: e$8.value
              }
            };
    }
    var e$9 = url._0;
    return {
            TAG: /* Error */1,
            _0: {
              path: ".url" + e$9.path,
              message: e$9.message,
              value: e$9.value
            }
          };
  }
  var e$10 = chromeId._0;
  return {
          TAG: /* Error */1,
          _0: {
            path: ".chromeId" + e$10.path,
            message: e$10.message,
            value: e$10.value
          }
        };
}

function fromDownloadItem(param) {
  return {
          chromeId: param.id,
          url: param.url,
          finalUrl: param.finalUrl,
          referrer: param.referrer,
          filename: param.filename,
          mime: param.mime,
          startTime: Date.parse(param.startTime),
          estimatedEndTime: OptionUtils$SmartcutsMacros.map(param.estimatedEndTime, (function (prim) {
                  return Date.parse(prim);
                })),
          totalBytes: param.totalBytes,
          fileSize: param.fileSize,
          tabOrigin: {
            TAG: /* Pending */1,
            _0: undefined
          }
        };
}

function stringify$2(v) {
  return JSON.stringify(v);
}

var Recording = {
  t_encode: t_encode$2,
  t_decode: t_decode$2,
  fromDownloadItem: fromDownloadItem,
  stringify: stringify$2
};

function t_encode$3(v) {
  return Js_dict.fromArray([
              [
                "chromeId",
                Decco.intToJson(v.chromeId)
              ],
              [
                "url",
                Decco.stringToJson(v.url)
              ],
              [
                "finalUrl",
                Decco.stringToJson(v.finalUrl)
              ],
              [
                "referrer",
                Decco.stringToJson(v.referrer)
              ],
              [
                "filename",
                Decco.stringToJson(v.filename)
              ],
              [
                "mime",
                Decco.stringToJson(v.mime)
              ],
              [
                "startTime",
                Decco.floatToJson(v.startTime)
              ],
              [
                "estimatedEndTime",
                Decco.optionToJson(Decco.floatToJson, v.estimatedEndTime)
              ],
              [
                "totalBytes",
                Decco.floatToJson(v.totalBytes)
              ],
              [
                "fileSize",
                Decco.floatToJson(v.fileSize)
              ],
              [
                "tabOrigin",
                t_encode$1(InterfaceBtwnRecordingAndPlayback$SmartcutsMacros.TabRef.t_encode, v.tabOrigin)
              ]
            ]);
}

function t_decode$3(v) {
  var dict = Js_json.classify(v);
  if (typeof dict === "number") {
    return Decco.error(undefined, "Not an object", v);
  }
  if (dict.TAG !== /* JSONObject */2) {
    return Decco.error(undefined, "Not an object", v);
  }
  var dict$1 = dict._0;
  var chromeId = Decco.intFromJson(Belt_Option.getWithDefault(Js_dict.get(dict$1, "chromeId"), null));
  if (chromeId.TAG === /* Ok */0) {
    var url = Decco.stringFromJson(Belt_Option.getWithDefault(Js_dict.get(dict$1, "url"), null));
    if (url.TAG === /* Ok */0) {
      var finalUrl = Decco.stringFromJson(Belt_Option.getWithDefault(Js_dict.get(dict$1, "finalUrl"), null));
      if (finalUrl.TAG === /* Ok */0) {
        var referrer = Decco.stringFromJson(Belt_Option.getWithDefault(Js_dict.get(dict$1, "referrer"), null));
        if (referrer.TAG === /* Ok */0) {
          var filename = Decco.stringFromJson(Belt_Option.getWithDefault(Js_dict.get(dict$1, "filename"), null));
          if (filename.TAG === /* Ok */0) {
            var mime = Decco.stringFromJson(Belt_Option.getWithDefault(Js_dict.get(dict$1, "mime"), null));
            if (mime.TAG === /* Ok */0) {
              var startTime = Decco.floatFromJson(Belt_Option.getWithDefault(Js_dict.get(dict$1, "startTime"), null));
              if (startTime.TAG === /* Ok */0) {
                var estimatedEndTime = Decco.optionFromJson(Decco.floatFromJson, Belt_Option.getWithDefault(Js_dict.get(dict$1, "estimatedEndTime"), null));
                if (estimatedEndTime.TAG === /* Ok */0) {
                  var totalBytes = Decco.floatFromJson(Belt_Option.getWithDefault(Js_dict.get(dict$1, "totalBytes"), null));
                  if (totalBytes.TAG === /* Ok */0) {
                    var fileSize = Decco.floatFromJson(Belt_Option.getWithDefault(Js_dict.get(dict$1, "fileSize"), null));
                    if (fileSize.TAG === /* Ok */0) {
                      var tabOrigin = t_decode$1(InterfaceBtwnRecordingAndPlayback$SmartcutsMacros.TabRef.t_decode, Belt_Option.getWithDefault(Js_dict.get(dict$1, "tabOrigin"), null));
                      if (tabOrigin.TAG === /* Ok */0) {
                        return {
                                TAG: /* Ok */0,
                                _0: {
                                  chromeId: chromeId._0,
                                  url: url._0,
                                  finalUrl: finalUrl._0,
                                  referrer: referrer._0,
                                  filename: filename._0,
                                  mime: mime._0,
                                  startTime: startTime._0,
                                  estimatedEndTime: estimatedEndTime._0,
                                  totalBytes: totalBytes._0,
                                  fileSize: fileSize._0,
                                  tabOrigin: tabOrigin._0
                                }
                              };
                      }
                      var e = tabOrigin._0;
                      return {
                              TAG: /* Error */1,
                              _0: {
                                path: ".tabOrigin" + e.path,
                                message: e.message,
                                value: e.value
                              }
                            };
                    }
                    var e$1 = fileSize._0;
                    return {
                            TAG: /* Error */1,
                            _0: {
                              path: ".fileSize" + e$1.path,
                              message: e$1.message,
                              value: e$1.value
                            }
                          };
                  }
                  var e$2 = totalBytes._0;
                  return {
                          TAG: /* Error */1,
                          _0: {
                            path: ".totalBytes" + e$2.path,
                            message: e$2.message,
                            value: e$2.value
                          }
                        };
                }
                var e$3 = estimatedEndTime._0;
                return {
                        TAG: /* Error */1,
                        _0: {
                          path: ".estimatedEndTime" + e$3.path,
                          message: e$3.message,
                          value: e$3.value
                        }
                      };
              }
              var e$4 = startTime._0;
              return {
                      TAG: /* Error */1,
                      _0: {
                        path: ".startTime" + e$4.path,
                        message: e$4.message,
                        value: e$4.value
                      }
                    };
            }
            var e$5 = mime._0;
            return {
                    TAG: /* Error */1,
                    _0: {
                      path: ".mime" + e$5.path,
                      message: e$5.message,
                      value: e$5.value
                    }
                  };
          }
          var e$6 = filename._0;
          return {
                  TAG: /* Error */1,
                  _0: {
                    path: ".filename" + e$6.path,
                    message: e$6.message,
                    value: e$6.value
                  }
                };
        }
        var e$7 = referrer._0;
        return {
                TAG: /* Error */1,
                _0: {
                  path: ".referrer" + e$7.path,
                  message: e$7.message,
                  value: e$7.value
                }
              };
      }
      var e$8 = finalUrl._0;
      return {
              TAG: /* Error */1,
              _0: {
                path: ".finalUrl" + e$8.path,
                message: e$8.message,
                value: e$8.value
              }
            };
    }
    var e$9 = url._0;
    return {
            TAG: /* Error */1,
            _0: {
              path: ".url" + e$9.path,
              message: e$9.message,
              value: e$9.value
            }
          };
  }
  var e$10 = chromeId._0;
  return {
          TAG: /* Error */1,
          _0: {
            path: ".chromeId" + e$10.path,
            message: e$10.message,
            value: e$10.value
          }
        };
}

function fromRecordingCommandValue(param) {
  return {
          chromeId: param.chromeId,
          url: param.url,
          finalUrl: param.finalUrl,
          referrer: param.referrer,
          filename: param.filename,
          mime: param.mime,
          startTime: param.startTime,
          estimatedEndTime: param.estimatedEndTime,
          totalBytes: param.totalBytes,
          fileSize: param.fileSize,
          tabOrigin: PromisedValue$SmartcutsMacros.getResolvedExn((function (_unit) {
                  return "Expect DownloadCommand.tabOrigin to be resolved when converting Recording -> Authoring";
                }), param.tabOrigin)
        };
}

function stringify$3(v) {
  return JSON.stringify(v);
}

var Authoring = {
  t_encode: t_encode$3,
  t_decode: t_decode$3,
  fromRecordingCommandValue: fromRecordingCommandValue,
  stringify: stringify$3
};

function t_encode$4(v) {
  if (v) {
    return [
            "CustomFilename",
            Decco.stringToJson(v._0)
          ];
  } else {
    return ["DefaultFilename"];
  }
}

function t_decode$4(v) {
  var jsonArr = Js_json.classify(v);
  if (typeof jsonArr === "number") {
    return Decco.error(undefined, "Not a variant", v);
  }
  if (jsonArr.TAG !== /* JSONArray */3) {
    return Decco.error(undefined, "Not a variant", v);
  }
  var jsonArr$1 = jsonArr._0;
  if (jsonArr$1.length === 0) {
    return Decco.error(undefined, "Expected variant, found empty array", v);
  }
  var tagged = jsonArr$1.map(Js_json.classify);
  var match = Belt_Array.getExn(tagged, 0);
  if (typeof match !== "number" && match.TAG === /* JSONString */0) {
    switch (match._0) {
      case "CustomFilename" :
          if (tagged.length !== 2) {
            return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
          }
          var v0 = Decco.stringFromJson(Belt_Array.getExn(jsonArr$1, 1));
          if (v0.TAG === /* Ok */0) {
            return {
                    TAG: /* Ok */0,
                    _0: /* CustomFilename */{
                      _0: v0._0
                    }
                  };
          }
          var e = v0._0;
          return {
                  TAG: /* Error */1,
                  _0: {
                    path: "[0]" + e.path,
                    message: e.message,
                    value: e.value
                  }
                };
      case "DefaultFilename" :
          if (tagged.length !== 1) {
            return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
          } else {
            return {
                    TAG: /* Ok */0,
                    _0: /* DefaultFilename */0
                  };
          }
      default:
        
    }
  }
  return Decco.error(undefined, "Invalid variant constructor", Belt_Array.getExn(jsonArr$1, 0));
}

function stringify$4(v) {
  if (v) {
    return "CustomFilename(" + (v._0 + ")");
  } else {
    return "DefaultFilename";
  }
}

var Filename = {
  t_encode: t_encode$4,
  t_decode: t_decode$4,
  stringify: stringify$4
};

function t_encode$5(v) {
  return Js_dict.fromArray([
              [
                "recordingReferrer",
                Decco.stringToJson(v.recordingReferrer)
              ],
              [
                "recordingUrl",
                Decco.stringToJson(v.recordingUrl)
              ],
              [
                "recordingFinalUrl",
                Decco.stringToJson(v.recordingFinalUrl)
              ],
              [
                "recordingFilename",
                Decco.stringToJson(v.recordingFilename)
              ],
              [
                "filename",
                t_encode$4(v.filename)
              ],
              [
                "tabOrigin",
                t_encode$1(InterfaceBtwnRecordingAndPlayback$SmartcutsMacros.TabRef.t_encode, v.tabOrigin)
              ]
            ]);
}

function t_decode$5(v) {
  var dict = Js_json.classify(v);
  if (typeof dict === "number") {
    return Decco.error(undefined, "Not an object", v);
  }
  if (dict.TAG !== /* JSONObject */2) {
    return Decco.error(undefined, "Not an object", v);
  }
  var dict$1 = dict._0;
  var recordingReferrer = Decco.stringFromJson(Belt_Option.getWithDefault(Js_dict.get(dict$1, "recordingReferrer"), null));
  if (recordingReferrer.TAG === /* Ok */0) {
    var recordingUrl = Decco.stringFromJson(Belt_Option.getWithDefault(Js_dict.get(dict$1, "recordingUrl"), null));
    if (recordingUrl.TAG === /* Ok */0) {
      var recordingFinalUrl = Decco.stringFromJson(Belt_Option.getWithDefault(Js_dict.get(dict$1, "recordingFinalUrl"), null));
      if (recordingFinalUrl.TAG === /* Ok */0) {
        var recordingFilename = Decco.stringFromJson(Belt_Option.getWithDefault(Js_dict.get(dict$1, "recordingFilename"), null));
        if (recordingFilename.TAG === /* Ok */0) {
          var filename = t_decode$4(Belt_Option.getWithDefault(Js_dict.get(dict$1, "filename"), null));
          if (filename.TAG === /* Ok */0) {
            var tabOrigin = t_decode$1(InterfaceBtwnRecordingAndPlayback$SmartcutsMacros.TabRef.t_decode, Belt_Option.getWithDefault(Js_dict.get(dict$1, "tabOrigin"), null));
            if (tabOrigin.TAG === /* Ok */0) {
              return {
                      TAG: /* Ok */0,
                      _0: {
                        recordingReferrer: recordingReferrer._0,
                        recordingUrl: recordingUrl._0,
                        recordingFinalUrl: recordingFinalUrl._0,
                        recordingFilename: recordingFilename._0,
                        filename: filename._0,
                        tabOrigin: tabOrigin._0
                      }
                    };
            }
            var e = tabOrigin._0;
            return {
                    TAG: /* Error */1,
                    _0: {
                      path: ".tabOrigin" + e.path,
                      message: e.message,
                      value: e.value
                    }
                  };
          }
          var e$1 = filename._0;
          return {
                  TAG: /* Error */1,
                  _0: {
                    path: ".filename" + e$1.path,
                    message: e$1.message,
                    value: e$1.value
                  }
                };
        }
        var e$2 = recordingFilename._0;
        return {
                TAG: /* Error */1,
                _0: {
                  path: ".recordingFilename" + e$2.path,
                  message: e$2.message,
                  value: e$2.value
                }
              };
      }
      var e$3 = recordingFinalUrl._0;
      return {
              TAG: /* Error */1,
              _0: {
                path: ".recordingFinalUrl" + e$3.path,
                message: e$3.message,
                value: e$3.value
              }
            };
    }
    var e$4 = recordingUrl._0;
    return {
            TAG: /* Error */1,
            _0: {
              path: ".recordingUrl" + e$4.path,
              message: e$4.message,
              value: e$4.value
            }
          };
  }
  var e$5 = recordingReferrer._0;
  return {
          TAG: /* Error */1,
          _0: {
            path: ".recordingReferrer" + e$5.path,
            message: e$5.message,
            value: e$5.value
          }
        };
}

function fromAuthoringCommandValue(param) {
  return {
          recordingReferrer: param.referrer,
          recordingUrl: param.url,
          recordingFinalUrl: param.finalUrl,
          recordingFilename: param.filename,
          filename: /* DefaultFilename */0,
          tabOrigin: param.tabOrigin
        };
}

function stringify$5(v) {
  return JSON.stringify(v);
}

function maybeAssignPlaybackTabId(recordingTabId, playbackTabId, cmdVal) {
  var tabOrigin = cmdVal.tabOrigin;
  if (tabOrigin.TAG === /* DownloadInNewTab */0) {
    var downloadInNewTab = tabOrigin._0;
    var tabRef = downloadInNewTab.openerTab;
    var tabRef$1 = downloadInNewTab.newTab;
    if (InterfaceBtwnRecordingAndPlayback$SmartcutsMacros.TabRef.equalsRecordingTabId(recordingTabId, tabRef)) {
      return {
              recordingReferrer: cmdVal.recordingReferrer,
              recordingUrl: cmdVal.recordingUrl,
              recordingFinalUrl: cmdVal.recordingFinalUrl,
              recordingFilename: cmdVal.recordingFilename,
              filename: cmdVal.filename,
              tabOrigin: {
                TAG: /* DownloadInNewTab */0,
                _0: {
                  newTab: downloadInNewTab.newTab,
                  openerTab: InterfaceBtwnRecordingAndPlayback$SmartcutsMacros.TabRef.assignPlaybackTabId(playbackTabId, tabRef),
                  newTabUrl: downloadInNewTab.newTabUrl
                }
              }
            };
    } else if (InterfaceBtwnRecordingAndPlayback$SmartcutsMacros.TabRef.equalsRecordingTabId(recordingTabId, tabRef$1)) {
      return {
              recordingReferrer: cmdVal.recordingReferrer,
              recordingUrl: cmdVal.recordingUrl,
              recordingFinalUrl: cmdVal.recordingFinalUrl,
              recordingFilename: cmdVal.recordingFilename,
              filename: cmdVal.filename,
              tabOrigin: {
                TAG: /* DownloadInNewTab */0,
                _0: {
                  newTab: InterfaceBtwnRecordingAndPlayback$SmartcutsMacros.TabRef.assignPlaybackTabId(playbackTabId, tabRef$1),
                  openerTab: downloadInNewTab.openerTab,
                  newTabUrl: downloadInNewTab.newTabUrl
                }
              }
            };
    } else {
      return cmdVal;
    }
  }
  var tabRef$2 = tabOrigin._0;
  if (InterfaceBtwnRecordingAndPlayback$SmartcutsMacros.TabRef.equalsRecordingTabId(recordingTabId, tabRef$2)) {
    return {
            recordingReferrer: cmdVal.recordingReferrer,
            recordingUrl: cmdVal.recordingUrl,
            recordingFinalUrl: cmdVal.recordingFinalUrl,
            recordingFilename: cmdVal.recordingFilename,
            filename: cmdVal.filename,
            tabOrigin: {
              TAG: /* DownloadInOriginalTab */1,
              _0: InterfaceBtwnRecordingAndPlayback$SmartcutsMacros.TabRef.assignPlaybackTabId(playbackTabId, tabRef$2)
            }
          };
  } else {
    return cmdVal;
  }
}

var Playback = {
  Filename: Filename,
  t_encode: t_encode$5,
  t_decode: t_decode$5,
  fromAuthoringCommandValue: fromAuthoringCommandValue,
  stringify: stringify$5,
  maybeAssignPlaybackTabId: maybeAssignPlaybackTabId
};

var CommandValue = {
  Recording: Recording,
  Authoring: Authoring,
  Playback: Playback
};

var FilenameStrategy = {};

function isMergeable(_config) {
  return false;
}

function isDynamic(param) {
  if (param.filenameStrategy) {
    return true;
  } else {
    return false;
  }
}

function isForAuthoringCommandValue(param, config) {
  return config.downloadId === param.chromeId;
}

function applyToAuthoringCommandValueToGetPlaybackCommandValue(param, maybeConfig) {
  var tmp;
  if (maybeConfig !== undefined) {
    var fname = maybeConfig.filenameStrategy;
    tmp = fname ? /* CustomFilename */({
          _0: fname._0
        }) : /* DefaultFilename */0;
  } else {
    tmp = /* DefaultFilename */0;
  }
  return {
          recordingReferrer: param.referrer,
          recordingUrl: param.url,
          recordingFinalUrl: param.finalUrl,
          recordingFilename: param.filename,
          filename: tmp,
          tabOrigin: param.tabOrigin
        };
}

function fromAuthoringCommandValue$1(param) {
  return {
          downloadId: param.chromeId,
          filenameStrategy: /* SaveUsingDefaultFilename */0,
          originalFilename: param.filename,
          playbackFormLabel: "What do you want to name the downloaded file?"
        };
}

function updateConfigWithAuthoringCommandValue(param, config) {
  return {
          downloadId: config.downloadId,
          filenameStrategy: config.filenameStrategy,
          originalFilename: param.filename,
          playbackFormLabel: config.playbackFormLabel
        };
}

function updateConfigWithPlaybackFormLabel(playbackFormLabel, config) {
  return {
          downloadId: config.downloadId,
          filenameStrategy: config.filenameStrategy,
          originalFilename: config.originalFilename,
          playbackFormLabel: playbackFormLabel
        };
}

var AuthoringConfig = {
  FilenameStrategy: FilenameStrategy,
  isMergeable: isMergeable,
  isDynamic: isDynamic,
  isForAuthoringCommandValue: isForAuthoringCommandValue,
  applyToAuthoringCommandValueToGetPlaybackCommandValue: applyToAuthoringCommandValueToGetPlaybackCommandValue,
  fromAuthoringCommandValue: fromAuthoringCommandValue$1,
  updateConfigWithAuthoringCommandValue: updateConfigWithAuthoringCommandValue,
  updateConfigWithPlaybackFormLabel: updateConfigWithPlaybackFormLabel
};

function t_encode$6(v) {
  return Js_dict.fromArray([
              [
                "originalFilename",
                Decco.stringToJson(v.originalFilename)
              ],
              [
                "playbackFormLabel",
                Decco.stringToJson(v.playbackFormLabel)
              ]
            ]);
}

function t_decode$6(v) {
  var dict = Js_json.classify(v);
  if (typeof dict === "number") {
    return Decco.error(undefined, "Not an object", v);
  }
  if (dict.TAG !== /* JSONObject */2) {
    return Decco.error(undefined, "Not an object", v);
  }
  var dict$1 = dict._0;
  var originalFilename = Decco.stringFromJson(Belt_Option.getWithDefault(Js_dict.get(dict$1, "originalFilename"), null));
  if (originalFilename.TAG === /* Ok */0) {
    var playbackFormLabel = Decco.stringFromJson(Belt_Option.getWithDefault(Js_dict.get(dict$1, "playbackFormLabel"), null));
    if (playbackFormLabel.TAG === /* Ok */0) {
      return {
              TAG: /* Ok */0,
              _0: {
                originalFilename: originalFilename._0,
                playbackFormLabel: playbackFormLabel._0
              }
            };
    }
    var e = playbackFormLabel._0;
    return {
            TAG: /* Error */1,
            _0: {
              path: ".playbackFormLabel" + e.path,
              message: e.message,
              value: e.value
            }
          };
  }
  var e$1 = originalFilename._0;
  return {
          TAG: /* Error */1,
          _0: {
            path: ".originalFilename" + e$1.path,
            message: e$1.message,
            value: e$1.value
          }
        };
}

function fromAuthoringConfig(param) {
  return {
          originalFilename: param.originalFilename,
          playbackFormLabel: param.playbackFormLabel
        };
}

function getPlaybackFormLabelFromParam(param) {
  return param.playbackFormLabel;
}

function removePrivateInfo(v) {
  return {
          originalFilename: "",
          playbackFormLabel: v.playbackFormLabel
        };
}

var ParamDescriptor = {
  t_encode: t_encode$6,
  t_decode: t_decode$6,
  fromAuthoringConfig: fromAuthoringConfig,
  getPlaybackFormLabelFromParam: getPlaybackFormLabelFromParam,
  removePrivateInfo: removePrivateInfo
};

var t_encode$7 = t_encode$4;

var t_decode$7 = t_decode$4;

function fromParamDescriptor(param) {
  var originalFilename = param.originalFilename;
  var originalNameParts = $$Array.of_list(StringUtils$SmartcutsMacros.split(".", originalFilename));
  var lastPart = Belt_Array.get(originalNameParts, originalNameParts.length - 1 | 0);
  if (lastPart !== undefined) {
    return /* CustomFilename */{
            _0: "yourOwnName." + lastPart
          };
  } else {
    return /* CustomFilename */{
            _0: originalFilename
          };
  }
}

function toCommandValueForPlayback(oldCommandValue, filename) {
  return {
          recordingReferrer: oldCommandValue.recordingReferrer,
          recordingUrl: oldCommandValue.recordingUrl,
          recordingFinalUrl: oldCommandValue.recordingFinalUrl,
          recordingFilename: oldCommandValue.recordingFilename,
          filename: filename,
          tabOrigin: oldCommandValue.tabOrigin
        };
}

var PlaybackParamValue = {
  t_encode: t_encode$7,
  t_decode: t_decode$7,
  stringify: stringify$4,
  fromParamDescriptor: fromParamDescriptor,
  toCommandValueForPlayback: toCommandValueForPlayback
};

exports.DownloadTabOrigin = DownloadTabOrigin;
exports.CommandValue = CommandValue;
exports.AuthoringConfig = AuthoringConfig;
exports.ParamDescriptor = ParamDescriptor;
exports.PlaybackParamValue = PlaybackParamValue;
/* StringUtils-SmartcutsMacros Not a pure module */
